/**
 * @typedef {
 * 'preTest' | 'Teach' | 'postTest'
 * } PtpMode
 */

/**
 * @typedef {'baseline' | 'active' | 'maintenance'} ActiveProgramStatus
 */

export const PTP_MODES = {
  PRE_TEST: 'preTest',
  TEACH: 'teach',
  POST_TEST: 'postTest',
};

export const PROGRAM_SCOPES = {
  LIBRARY: 'Library',
  CLIENT: 'Programs',
};

export const PROGRAM_DETAILS_VIEWS = {
  PROGRAM: 'program',
  TARGET: 'target',
};

export const ACTIVE_PROGRAM_STATUSES = ['baseline', 'active', 'maintenance'];

export const PROGRAM_STATUSES = /** @type {const} */ ({
  ACTIVE: 'active',
  BASELINE: 'baseline',
  CLOSED: 'closed',
  DISCONTINUED: 'discontinued',
  HOLD: 'hold',
  MAINTENANCE: 'maintenance',
  WAITING: 'waiting',
});

/** @typedef {typeof PROGRAM_STATUSES[keyof typeof PROGRAM_STATUSES]} ProgramStatus */

export const RETHINK_PROGRAM_NAMES = {
  BEHAVIOR_REDUCTION: 'Behavior Reduction',
};

export const PROGRAM_DATA_TYPES = {
  INCIDENTS: 'incidents',
};

export const PROGRAM_TYPES = {
  ASR: 'asr',
  BEHAVIOUR: 'behaviour',
  DURATION: 'duration',
  ESDM: 'esdm',
  FREQUENCY: 'frequency',
  INSTRUCTIONS: 'instructions',
  INTERVAL: 'interval',
  PTP: 'ptp',
  SBT: 'sbt',
  SET: 'set',
  SIMPLE: 'simple',
  TASK_ANALYSIS: 'taskAnalysis',
};
export const PLANNED_MASTERY_QUANTITY_MIN = 1;
export const PLANNED_MASTERY_QUANTITY_MAX = 50;
